if (!customElements.get('header-navigation')) {
    class HeaderNavigation extends HTMLElement {
        constructor() {
            super();
        }

        EventUnSubscriber = undefined;
        connectedCallback() {
            this.Initialize()
        }
        disconnectedCallback() {
            if (this.EventUnSubscriber) {
                this.EventUnSubscriber();
            }
        }
        connectedCallback() {
            this.Initialize()
        }
        Initialize() {
            this.Active = (this.dataset.state === "Active")
            const Hamburger = this.querySelector('.Icon-Hamburger')
            if (Hamburger){
                this.Hamburger = Hamburger
            }
            switch (this.dataset.openType) {
                case 'Hover':
                    this.addEventListener('mouseenter', () => this.MouseEnter())
                    this.addEventListener('mouseleave', () => this.MouseLeave())
                    break
                case 'Click':
                    const Toggler = this.querySelector('[data-toggler]')
                    Toggler?.addEventListener('click', () => this.Toggle())
                    break
            }
            this.InitializeOpeners()
            this.InitializeClosers()
            this.InitializeForms()
            this.EventUnSubscriber = SubscribeToEvent(`CloseDrawer`, (eventData) => {
                this.OnEvent(eventData)
            });
        }
        OnEvent() {
            this.MouseLeave()
        } 
        MouseEnter( ){
            if(this.Active !== true) {
                TriggerEvent('HeaderDrawerEvent', {open: true, close: false})
                this.Activate()
            }
        }
        MouseLeave() {
            if (this.PreventMouseOut) return;
            if(this.Active !== false) {
                TriggerEvent('HeaderDrawerEvent', {open: false, close: true})
                this.DeActivate()
            }

        }
        Toggle(){
            this.Active ? this.MouseLeave() : this.MouseEnter()
        }
        Activate() {
            this.Active = true
            this.dataset.state = 'Active'
            if (this.Hamburger) {
                this.Hamburger.dataset.state = 'Active'
            }
            LockScroll()
        }
        DeActivate() {
            this.Active = false
            this.dataset.state = 'InActive'
            if (this.Hamburger) {
                this.Hamburger.dataset.state = 'InActive'
            }
            this.CloseSubDrawers()
            if(theme.Overlay.dataset.active !== 'true') {
                UnLockScroll()
            }
        }
        InitializeOpeners() {
            this.Openers = this.querySelectorAll('[data-opener]')
            this.SubDrawers = this.querySelectorAll('[data-open]')
            this.Openers.forEach(Opener => {
                Opener.addEventListener('click', (e) => this.HandleOpenerClick(e.target));
            });
        }
        InitializeClosers() {
            this.SubClosers = this.querySelectorAll('[data-sub-closer]')
            this.SubClosers.forEach(Closer => {
                Closer.addEventListener('click', () => this.CloseSubDrawers());
            });
        }
        InitializeForms() {
            this.Inputs = this.querySelectorAll('form')
            this.Inputs.forEach(element => {
                element.addEventListener('focusin', () => this.PreventMouseOut = true);
                element.addEventListener('focusout', () => this.PreventMouseOut = false);
            })
        }
        HandleOpenerClick(target) {
            this.CloseSubDrawers()
            this.Activate()
            this.OpenSubDrawer(target.dataset.opener)
        }
        CloseSubDrawers() {
            this.SubDrawers.forEach(SubDrawer => SubDrawer.setAttribute('data-state', 'InActive'))
        }
        OpenSubDrawer(Value) {
            const SubDrawer = this.querySelector(`[data-open='${Value}']`)
            if (SubDrawer) {
                SubDrawer?.setAttribute('data-state', SubDrawer.dataset.state !=='Active' ? 'Active':'InActive')
            }
        }
    }
    customElements.define('header-navigation', HeaderNavigation)
}
if (!customElements.get('drawer-cover')) {
    class DrawerCover extends HTMLElement {
        constructor() {
            super();
        }

        EventUnSubscriber = undefined;
        connectedCallback() {
            this.Initialize()
        }
        Initialize() {
            this.EventUnSubscriber = SubscribeToEvent(`HeaderDrawerEvent`, (eventData) => {
                this.OnEvent(eventData)
            });
            this.addEventListener('click', () => this.EmitClose())
            AttachResizeObserver(this)

        }
        disconnectedCallback() {
            if (this.EventUnSubscriber) {
                this.EventUnSubscriber();
            }
        }
        OnEvent(eventData) {
            if(eventData?.open == true) {
                this.Activate()
            } else if(eventData?.close == true) {
                this.DeActivate()
            }
        }
        OnResize(entry) {
            if (this?.dataset?.state === "Active") {
                this.EmitClose()
            }
        }
        EmitClose() {
            this.DeActivate()
            TriggerEvent('CloseDrawer')
        }
        Activate() {
            this.setAttribute('data-state', 'Active')
        }
        DeActivate() {
            this.setAttribute('data-state', 'InActive')
        }
    }
    customElements.define('drawer-cover', DrawerCover)
}